import PendingAdjustmentDetailsTable from './PendingAdjustmentDetailsTable'

export default PendingAdjustmentDetailsTable
